import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {createInputIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {PlayerEnums} from '../../../../shared/GameEnums.ts'
import PlayerConstants = PlayerEnums.PlayerConstants

export class UIMPopupPlayerSearchView extends ViewPopup {
    readonly inputField: HTMLInputElement
    private canSearch: boolean = false

    constructor(checkAction: (searchValue: string) => void) {
        super({key: 'strings:popups.searchPlayer.title'}, undefined, () => undefined, () => undefined, true, {checkButtonCustomContent: {key: 'strings:popups.searchPlayer.checkButton'}})

        this.disableCheckButton()
        this.inputField = this.createInput()

        const submitQuery = () => {
            const value = this.inputField.value
            checkAction(value)
            this.removePopup()
        }

        this.checkButton.onclick = submitQuery

        this.inputField.addEventListener('keydown', (event) => {
            if(event.key === 'Enter') {
                if(!this.canSearch) return
                event.preventDefault()
                submitQuery()
            }
        })

        this.inputField.addEventListener('input', () => {
            if(this.inputField.value.length >= PlayerConstants.MIN_USERNAME_LENGTH && this.inputField.value.length <= PlayerConstants.MAX_USERNAME_LENGTH) {
                this.enableCheckButton()
                return
            }
            this.disableCheckButton()
        })

        this.show()
        this.inputField.focus()
    }

    private createInput() {
        const input = createInputIn(this.body, 'm-popup-input', 'm-popup-input')
        input.placeholder = 'Player Name'
        return input
    }

    override enableCheckButton() {
        super.enableCheckButton()
        this.canSearch = true
    }

    override disableCheckButton() {
        super.disableCheckButton()
        this.canSearch = false
    }
}
